export default {
  SAVE_STORY_EMAIL_TEMPLATE_REQUEST: (identifier = '') => `SAVE_STORY_EMAIL_TEMPLATE_REQUEST_${identifier.toUpperCase()}`,
  SAVE_STORY_EMAIL_TEMPLATE_SUCCESS: (identifier = '') => `SAVE_STORY_EMAIL_TEMPLATE_SUCCESS_${identifier.toUpperCase()}`,
  SAVE_STORY_EMAIL_TEMPLATE_FAILURE: (identifier = '') => `SAVE_STORY_EMAIL_TEMPLATE_FAILURE_${identifier.toUpperCase()}`
}
